"use client";

import { usePathname } from "next/navigation";
import Header from "@/components/common/header";

const PUBLIC_PATHS = ["/login", "/signup", "/forgot-identifier"];

interface AppContainerProps {
  children: React.ReactNode;
}

const AppContainer: React.FC<AppContainerProps> = ({ children }) => {
  const pathname = usePathname();
  const isPublic = PUBLIC_PATHS.some((path) => pathname?.startsWith(path));

  return (
    <div className="relative min-h-screen">
      {!isPublic && <Header />}
      <div className={!isPublic ? "pt-16 pb-1" : ""}>{children}</div>
    </div>
  );
};

export default AppContainer;
